import { render, staticRenderFns } from "./AssessmentPreview.vue?vue&type=template&id=4acc11da&scoped=true"
import script from "./AssessmentPreview.vue?vue&type=script&lang=js"
export * from "./AssessmentPreview.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPreview.vue?vue&type=style&index=0&id=4acc11da&prod&scoped=true&lang=css"
import style1 from "./AssessmentPreview.vue?vue&type=style&index=1&id=4acc11da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc11da",
  null
  
)

export default component.exports